import { InjectionToken } from "@angular/core";

export interface SystemStateEndpoints {
    getSystemState: string;
}

export const SYSTEM_STATE_API_TOKENS = new InjectionToken<SystemStateEndpoints>("System state endpoints token");
